import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TabsGroup } from '@unified-checkout/design-system';

import type { ITabProps } from '@app/dashboard/types/innerLayout/balance_and_transfers/transfers/table-tabs';
import { transfersStatusFilters } from '@app/dashboard/constants/balance_and_transfers/transfers/tabs';

import styles from './table-tabs.module.scss';

const TableTabs = ({
  activeTab,
  handleTabChange,
  disableTabs,
  tabsProps,
}: ITabProps) => {
  const { t } = useTranslation();

  const memoizedTabs = useMemo(() => transfersStatusFilters(t), [t]);

  const formattedTabs = useMemo(() => {
    if (!activeTab) return;

    return memoizedTabs.map((tab) => {
      const counter =
        tabsProps?.find((item) => tab.id === item.key)?.count || 0;

      return {
        ...tab,
        active: activeTab.id === tab.id,
        onClickHandler: () => handleTabChange(tab),
        tabLabel: tab.label,
        tabName: tab.name,
        id: tab.id,
        disabled: disableTabs,
        counter,
      };
    });
  }, [activeTab, tabsProps, memoizedTabs, disableTabs]);

  useEffect(() => {
    if (!activeTab) {
      handleTabChange(memoizedTabs[0]);
    }
  }, []);

  return (
    <div className={styles['table-tabs']}>
      <TabsGroup tabsProps={formattedTabs} orientation="horizontal" />
    </div>
  );
};

export default TableTabs;
